import { render } from "./BarcodeCustomField.vue?vue&type=template&id=37eb0bfa&scoped=true"
import script from "./BarcodeCustomField.vue?vue&type=script&lang=ts"
export * from "./BarcodeCustomField.vue?vue&type=script&lang=ts"

import "./BarcodeCustomField.vue?vue&type=style&index=0&id=37eb0bfa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37eb0bfa"

export default script